import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@cargomatic/ui';

import { withTranslation } from 'react-i18next';
import CreateLocation from './CreateLocation';

class CreateLocationModal extends React.Component {
  render() {
    return (
      <Dialog open={this.props.show} onOpenChange={this.props.onHide}>
        <DialogContent className="sm:max-w-[700px] max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle>{this.props.t('CREATE_LOCATION')}</DialogTitle>
          </DialogHeader>
          <CreateLocation
            onCreate={this.props.onCreate}
            onCreateLocationCancel={this.props.onHide}
            error={this.props.error}
            locationPending={this.props.locationPending}
          />
        </DialogContent>
      </Dialog>
    );
  }
}

export default withTranslation()(CreateLocationModal);
